
<div class="h-100">
  <alert-component></alert-component>
  <modal-component></modal-component>
  <video-component></video-component>
  <component :is="view.component"></component>
</div>
